<header class="mb-3 flex items-start justify-between gap-3">
  <h2 class="text-body text-gold-cream font-bold">Cargar ticket</h2>

  <button
    type="button"
    aria-label="Cerrar"
    class="text-blue-sky shrink-0 transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
    (click)="dialogRef.close()">
    <icon
      name="circle-x"
      [size]="20" />
  </button>
</header>

<p class="text-label text-blue-frost">Toma una foto o sube el archivo de tu ticket para sumar copas</p>

<label
  class="photo-option glow-frost mt-4 flex w-full cursor-pointer items-center gap-1 rounded-xl py-px pr-3 pl-2 text-left transition-transform duration-100 ease-out active:scale-[0.99] motion-reduce:transition-none motion-reduce:active:scale-100">
  <img
    priority
    ngSrc="https://superlikers-themes.s3.us-east-1.amazonaws.com/pernod2/take_photo.png"
    width="671"
    height="620"
    class="size-15 shrink-0 object-contain"
    alt="" />

  <span class="flex-1">
    <span class="text-body text-blue-frost block font-bold">TOMAR FOTO</span>
    <span class="text-label text-blue-frost block">Usa la cámara ahora</span>
  </span>

  <span
    aria-hidden="true"
    class="btn-secondary grid size-6 shrink-0 place-items-center rounded-full text-white">
    <icon
      name="chevron-right"
      [size]="14" />
  </span>

  <input
    class="sr-only"
    type="file"
    accept="image/*"
    capture="environment"
    data-test="ticket-camera"
    (change)="select($event)" />
</label>

@if (preview()) {
<div
  class="border-blue-sky/60 mt-3 flex items-center gap-3 rounded-2xl border px-3 py-3"
  data-test="ticket-preview">
  <img
    class="border-blue-navy size-16 shrink-0 rounded-xl border object-cover"
    [src]="preview()"
    alt="Vista previa de tu ticket" />

  <p class="min-w-0 flex-1">
    <span class="text-body block truncate font-bold text-white">{{ fileName() }}</span>
    <span class="text-label text-blue-frost block">Listo para subir</span>
  </p>
</div>
} @else {
<label class="border-blue-sky/60 mt-3 flex w-full cursor-pointer flex-col items-center rounded-2xl border border-dashed px-4 py-[18px] shadow-[inset_0_4px_4px_rgb(0_0_0/0.25)]">
  <span
    aria-hidden="true"
    class="btn-secondary text-blue-frost mb-3 grid size-8 place-items-center rounded-full">
    <icon
      name="upload"
      [size]="20" />
  </span>

  <span class="text-body text-blue-frost font-bold">Subir archivo</span>
  <span class="text-label text-blue-frost opacity-60">JPG · PNG · WEBP · máx 5MB</span>

  <input
    class="sr-only"
    type="file"
    accept="image/jpeg,image/png,image/webp"
    data-test="ticket-input"
    (change)="select($event)" />
</label>
} @if (error()) {
<p
  class="text-label text-gold-peach mt-3 text-center"
  role="alert"
  data-test="ticket-error">
  {{ error() }}
</p>
}

<div class="mt-5 flex gap-3">
  <button
    uiButton
    variant="secondary"
    type="button"
    class="flex-1"
    (click)="dialogRef.close()">
    Cancelar
  </button>

  <button
    uiButton
    type="button"
    class="flex-1"
    data-test="ticket-submit"
    [disabled]="!hasFile() || loading()"
    (click)="submit()">
    {{ loading() ? 'Subiendo…' : retryable() ? 'Reintentar' : 'Subir' }}
  </button>
</div>
